import React from 'react';
import { FlatList, Text, View } from 'react-native';
import { getCleanUrl } from '../../utils/Helper';
import CustomPressable from '../customPressable/customPressable';
import { ImageComp } from '../Image/Image';
import { CHEVRON_RIGHT } from '../../assets';
import CustomFlatList from '../customFlatList';
import { useCssStyle } from '../../customHook/getCssStyle';

const BannerWidget = props => {
  const { listItemData, displayName, handleOnWidgetClick } = props || {};
  const getStyles = useCssStyle();


  const renderItem = ({ item }) => (

    <CustomPressable onPress={() => handleOnWidgetClick(item)} style={getStyles(['bannerWidgetsWidgetContainer', `bannerWidgetsWidgetContainer_${item.widgetMetaHtmlId}` ,`bannerWidgetsWidgetContainer_${item.id}`])} id={`bannerWidgetsWidgetContainer bannerWidgetsWidgetContainer_${item.widgetMetaHtmlId} bannerWidgetsWidgetContainer_${item.id}`} >

      <>
        <View style={getStyles(['bannerWidgetImageStyle', `bannerWidgetImageStyle_${item.widgetMetaHtmlId}`, `bannerWidgetImageStyle_${item.id}`])} id={`bannerWidgetImageStyle bannerWidgetImageStyle_${item.widgetMetaHtmlId} bannerWidgetImageStyle_${item.id}`}>
            <ImageComp
              source={getCleanUrl(item?.btnImageUrl)}
              style={getStyles(['bannerWidgetImage', `bannerWidgetImage_${item.widgetMetaHtmlId}`, `bannerWidgetImage_${item.id}`])}
              id={`bannerWidgetImage bannerWidgetImage_${item.widgetMetaHtmlId} bannerWidgetImage_${item.id}`}
            />
        </View>

        <View style={getStyles(['bannerWidgetTextContainer', `bannerWidgetTextContainer_${item.widgetMetaHtmlId}`, `bannerWidgetTextContainer_${item.id}`])} id={`bannerWidgetTextContainer bannerWidgetTextContainer_${item.widgetMetaHtmlId} bannerWidgetTextContainer_${item.id}`}>
          {item?.widgetTitle && <Text style={getStyles(['bannerWidgetTitle', `bannerWidgetTitle_${item.widgetMetaHtmlId}`, `bannerWidgetTitle_${item.id}`])} numberOfLines={2} id={`bannerWidgetTitle bannerWidgetTitle_${item.widgetMetaHtmlId} bannerWidgetTitle_${item.id}`} >{item?.widgetTitle}</Text>}
          {item?.widgetDesc && <Text style={getStyles(['bannerWidgetDescription', `bannerWidgetDescription_${item.bannerWidgetTitle}`, `bannerWidgetDescription_${item.id}`])} id={`bannerWidgetDescription bannerWidgetDescription_${item.bannerWidgetTitle} bannerWidgetDescription_${item.id}`} numberOfLines={2}>{item?.widgetDesc}</Text>}
        </View>

        <View style={getStyles(['bannerWidgetArrow_container', `bannerWidgetArrow_container_${item.widgetMetaHtmlId}`, `bannerWidgetArrow_container_${item.id}`])} id={`bannerWidgetArrow_container bannerWidgetArrow_container_${item.widgetMetaHtmlId} bannerWidgetArrow_container_${item.id}`}>
          <ImageComp source={CHEVRON_RIGHT } style={getStyles(['bannerWidgetArrow', `bannerWidgetArrow_${item.widgetMetaHtmlId}`, `bannerWidgetArrow_${item.id}`])} id={`bannerWidgetArrow bannerWidgetArrow_${item.widgetMetaHtmlId} bannerWidgetArrow_${item.id}`} />
        </View>
      </>
    </CustomPressable>
  );

  return (
    <View style={getStyles(['bannerWidgetMainContainer', `bannerWidgetMainContainer_${listItemData[0].widgetMetaHtmlId}`, `bannerWidgetMainContainer_${listItemData[0].id}`])} id={`bannerWidgetMainContainer bannerWidgetMainContainer_${listItemData[0].widgetMetaHtmlId} bannerWidgetMainContainer_${listItemData[0].id}`}>
      <CustomFlatList
      nestedScrollEnabled={true}
        data={listItemData}
        renderItem={renderItem}
        keyExtractor={item => item?.widgetId?.toString()}
        showsVerticalScrollIndicator={false}
      />
    </View>
  );
};

export default React.memo(BannerWidget);
